import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
const faqs = [{
  question: 'Are online degrees respected by employers?',
  answer: 'Yes. Employers increasingly view online degrees from accredited schools exactly the same as traditional on-campus degrees. What matters most is the accreditation of the school and the skills you build — not where you sat while you learned them.'
}, {
  question: 'How do I know if a school is accredited?',
  answer: "We only partner with schools that hold regional or national accreditation — an independent quality review — recognized by the U.S. Department of Education. You can verify any school's status on their website or through the Database of Accredited Postsecondary Institutions and Programs."
}, {
  question: 'Can I get financial aid for an online degree?',
  answer: 'Yes. Students enrolled in accredited online degree programs are generally eligible for the same federal grants and loans as on-campus students. Fill out the Free Application for Federal Student Aid (FAFSA) to see what you qualify for.'
}, {
  question: 'How much does this matching service cost?',
  answer: 'Nothing. Our matching service is completely free for you. Partner schools compensate us when we connect them with prospective students, which is what keeps this resource free.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const toggleFaq = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="w-full bg-surface py-14 md:py-20" data-id="element-195" data-mp="2advva5ln387a">
      <div className="max-w-3xl mx-auto px-5 sm:px-6 lg:px-8" data-id="element-196" data-mp="2oe6ohfaf8yvm">
        <div className="text-center mb-8" data-id="element-197" data-mp="2odnf4myu7it7">
          <h2 className="text-3xl md:text-4xl font-bold text-ink mb-3" data-id="element-198" data-mp="2jeu2sxvadxum">
            Frequently Asked Questions
          </h2>
          <p className="text-base text-ink-secondary max-w-2xl mx-auto" data-id="element-199" data-mp="u1gw51zpbxqc">
            Common questions about online education and how our matching works.
          </p>
        </div>

        <div className="divide-y divide-hairline overflow-hidden rounded-2xl border border-hairline bg-background-alt" data-id="element-200" data-mp="2p4di41k14n54">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <div key={faq.question} data-id="element-201" data-mp="2z0owqy73dp2q" data-mpi={index}>
                <h3 data-id="element-202" data-mp="2z3un0grgix01">
                  <button type="button" onClick={() => toggleFaq(index)} aria-expanded={isOpen} aria-controls={`faq-panel-${index}`} id={`faq-trigger-${index}`} className="flex w-full items-center justify-between gap-4 px-5 py-5 text-left transition-colors duration-150 ease-out hover:bg-surface focus:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-inset md:px-6" data-id="element-203" data-mp="333d8per3rc3x">
                    <span className="text-base md:text-lg font-semibold text-ink" data-id="element-204" data-mp="3mrchik23w96p">
                      {faq.question}
                    </span>
                    <span className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full transition-colors duration-150 ease-out ${isOpen ? 'bg-primary text-white' : 'bg-surface text-primary ring-1 ring-inset ring-hairline'}`} data-id="element-205" data-mp="3qu8tvt11z927">
                      <ChevronDownIcon aria-hidden="true" className={`h-4 w-4 transition-transform duration-200 ease-out ${isOpen ? 'rotate-180' : ''}`} data-id="element-206" data-mp="1k2axjh5wnuz0" />
                    </span>
                  </button>
                </h3>
                <div id={`faq-panel-${index}`} role="region" aria-labelledby={`faq-trigger-${index}`} hidden={!isOpen} className="px-5 pb-5 md:px-6" data-id="element-207" data-mp="165fkldmj9jdo">
                  <p className="text-sm md:text-base leading-relaxed text-ink-secondary" data-id="element-208" data-mp="22udfcvua9hau">
                    {faq.answer}
                  </p>
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}